import theme from "src/themeNew";

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '90%',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    margin: '20px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: '1px solid #F2F4F7',
    flexShrink: 0,
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 500,
    fontSize: '14px',
    color: '#101828',
    textDecoration: 'none',
    cursor: 'pointer',
    marginRight: '8px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#101828',
  },
  status: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  statusLabel: {
    fontSize: '14px',
    color: '#101828',
    fontWeight: 500,
  },
  statusRunning: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#67CB24',
    backgroundColor: '#E8FADD',
  },
  statusStopped: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#6D788D',
    backgroundColor: '#E7E9ED',
  },
  statusEditing: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#0E62D8',
    backgroundColor: '#DBEAFF',
  },
  statusPublished: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 500,
    color: '#67CB24',
    backgroundColor: '#E8FADD',
  },
  stopButton: {
    backgroundColor: '#fff',
    color: '#101828',
    border: '1px solid #D0D5DD',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    }
  },
  editButton: {
    ml: 2,
    borderColor: '#3E8AFF',
    color: '#3E8AFF',
    textTransform: 'none',
    '&:hover': {
      borderColor: '#2563EB',
      backgroundColor: '#F0F9FF'
    }
  },
  publishButton: {
    ml: 0,
    backgroundColor: '#3E8AFF',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#2563EB'
    }
  },
  saveButton: {
    ml: 2,
    backgroundColor: '#3E8AFF',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#2563EB'
    }
  },
  publishingContainer: {
    ml: 2,
    display: 'flex',
    alignItems: 'center',
  },
  publishingSpinner: {
    color: '#10B981',
  },
  publishingText: {
    ml: 1,
    fontSize: '14px',
    color: '#10B981',
  },
  nodeTypeDisabled: {
    opacity: 0.8,
    pointerEvents: 'none',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: '#f5f5f5',
  },
  loadingSpinner: {
    color: '#3E8AFF',
    mb: 2,
  },
  loadingText: {
    color: '#666666',
  },
  mainContainer: {
    display: 'flex',
    height: 'calc(100% - 56px)',
    flex: '1 1 auto',
    minHeight: '0',
  },
  sidePanel: {
    width: '250px',
    borderRight: '1px solid #F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    overflow: 'auto',
  },
  nodeType: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
    marginBottom: '8px',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    }
  },
  nodeTypeIcon: {
    color: '#3E8AFF',
    fontSize: '20px',
  },
  nodeTypeText: {
    fontSize: '14px',
    color: '#101828',
  },
  canvas: {
    flex: 1,
    position: 'relative',
    overflow: 'hidden',
    background: 'radial-gradient(circle, #f0f0f0 1px, transparent 1px)',
    backgroundSize: '20px 20px',
  },
  backdrop: {
    zIndex: 111111,
    color: '#ffffff',
  },
  spinner: {
    color: theme.palette.background.white,
  },
  controlsContainer: {
    position: 'absolute',
    bottom: '16px',
    right: '16px',
    zIndex: 10,
  },
  alertContainer: {
    '& .MuiAlert-root': {
      backgroundColor: '#fff',
      borderRadius: '12px',
      boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '14px 20px',
      fontSize: '14px',
      fontWeight: 500,
      color: theme.palette.text.primary,
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    '& .MuiAlert-icon': {
      padding: 0,
      margin: 0,
      fontSize: '24px',
    },
    '& .MuiAlert-message': {
      padding: 0,
      flex: 1,
    },
    '& .MuiAlert-action': {
      padding: 0,
      margin: 0,
    }
  },
  successAlert: {
    '& .MuiAlert-icon': {
      color: '#72E128',
    }
  },
  errorAlert: {
    '& .MuiAlert-icon': {
      color: theme.palette.error.main,
    }
  }
};

export default styles;
